import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import ActiveAdSpacesAdminList from './components/ActiveAdSpacesAdminList';

const ActiveAdSpacesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="User admin tabs">
        <Tab label="List Active adSpaces" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <ActiveAdSpacesAdminList />}
      </Box>
    </Box>
  );
};

export default ActiveAdSpacesAdminPage;